module.exports = __webpack_public_path__ + "img/cwjh@2x.02e23a8c.png";